// import { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FiExternalLink } from "react-icons/fi";
// import { getDecryptedData } from "../../config/crypto";
// import { IMAGE_URL, REACT_APP_API_PORT, VIDEO_URL } from "../../Api";
// import "react-circular-progressbar/dist/styles.css";
// import axios from "axios";
// import Loader from "../Loader";
// import { toast } from "react-toastify";
// import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
// import { motion, AnimatePresence } from "framer-motion";
// import { FaFileAlt } from "react-icons/fa";
// const MyPrompts = () => {
//     const navigate = useNavigate()
//     const [data, setData] = useState([]);
//     const [isLoading, setIsLoading] = useState(false);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//     const [totalItems, setTotalItems] = useState(0);
//     const [limit, setLimit] = useState(8);
//     const [copiedId, setCopiedId] = useState(null);
//     const getData = async (page=currentPage) => {
//       try {
//         setIsLoading(true);
//         const token = getDecryptedData("token")
//         const user = getDecryptedData("user")
//               let userId = ""
//               if (user) {
//                 userId = user._id
//               }
//         const res = await axios.get(
//           `${REACT_APP_API_PORT}user/frontend/user_save_prompt_list?limit=${limit}&page=${page}&userId=${userId}`,
//           {
//             headers: {
//                 "Content-Type": "application/json",
//                 "x-access-token": token,
//             },
//         }
//         );
//         setIsLoading(false);
//         if (res.data.status) {
//           setData(res.data.data);
//           setTotalPages(res.data.pagination?.totalPages);
//           setTotalItems(res.data.pagination?.totalItems);
//         }
//         else{
//             setData([])
//             setTotalItems(0)
//             setTotalPages(0)
//         }
//       } catch (err) {
//         setIsLoading(false);
//         console.log(err);
//       }
//     };
  
//     useEffect(() => {
//       getData(currentPage);
//     }, [currentPage, limit]);
  
//     const handleLoadMore = () => {
//       setLimit((prevLimit) => prevLimit + 8);
//     };
  
  
  
//     const handleToolNavigate = async (toolId) => {
//       const user = getDecryptedData("user");
//       if (!user) {
//         navigate(`/login`)
//       }
//       if (user) {
//         try {
//           setIsLoading(true)
//           const token = getDecryptedData('token')
//           const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-prompt`, {
//             prompt_id: toolId,
//           }, {
//             headers: {
//               'Content-Type': 'application/json',
//               'x-access-token': token
//             }
//           });
//           setIsLoading(false)
//           if (res.data.status) {
//             getData(1)
//             setCurrentPage(1)
//           }
//         }
//         catch (err) {
//           setIsLoading(false)
//           if (err.response.data.status === false) {
//             toast.error(err.response.data.message)
//           }
//         }
//       }
//     }

//     return (
//         <div className="container py-4">
//             <Loader isLoading={isLoading} />
//             <section className="bg-background-back1 overflow-hidden">
//         <div className="container max-w-[80rem] mx-auto px-4 pt-5">
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {data?.slice(0, limit).map((item) => (
//               <div
//                                               key={item._id}
//                                               className="blurBox bg-gray-900 rounded-xl overflow-hidden shadow-lg p-4 transition-transform duration-200"
//                                           // onClick={() => openSidebar(item)}
//                                           >
//                                               <div className="flex items-center gap-2"
//                                               // onClick={() => openSidebar(item)}
//                                               // onClick={() => {
//                                               //     navigate(`/prompts-detail/${item?._id}`)
//                                               // }}
//                                               >
//                                                   {/* <div className="relative">
//                                   <img
//                                     src={item.logo ? IMAGE_URL + item.logo + "?type=tool" : "/default.jpeg"}
//                                     // onError={(e)=>e.src.target='/default.jpeg'}
//                                     onError={(e) => {
//                                       e.target.onerror = null; // Prevents infinite loop if default image fails
//                                       e.target.src = '/default.jpeg';
//                                     }}
//                                     alt={`${item.tool_name} logo`}
//                                     className="h-12 w-12 rounded-full"
//                                   />
//                                   {
//                                     (item?.isVerified && item?.isVerified === "Yes") &&
//                                     <span className="absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center">
//                                       <PiSealCheckFill className="text-primary h-4 w-4 bg-white rounded-full" />
//                                     </span>
//                                   }
              
//                                 </div> */}
//                                                   <div className="flex flex-col truncate">
//                                                       <h5 className="text-lg font-bold text-white truncate">
//                                                           {item?.title?.length > 20 ? `${item?.title?.slice(0, 20)}...` : item.title}
//                                                       </h5>
//                                                       <p className="text-sm text-gray-400 truncate flex items-center">
//                                                           <FaFileAlt className="mr-1" size={14} /> Prompt
//                                                       </p>
//                                                   </div>
//                                               </div>
//                                               <p className="text-sm text-gray-400 truncate">{item.short_description}</p>
//                                               <img
//                                                   // onClick={() => {
//                                                   //     if (item?.tool_name) {
//                                                   //         navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
//                                                   //     }
//                                                   //     else {
//                                                   //         navigate(`/tool-detail/${item?._id}`)
//                                                   //     }
//                                                   // }}
//                                                   src={item.image ? IMAGE_URL + item.image : "/just-launch-default.png"}
//                                                   onError={(e) => {
//                                                       e.target.onerror = null; // Prevents infinite loop if default image fails
//                                                       e.target.src = '/just-launch-default.png';
//                                                   }}
//                                                   alt={item.title}
//                                                   className="w-full mt-3 rounded-lg object-cover h-40 lg:h-40"
//                                               />
//                                               <div className="flex justify-between items-center mt-2">
//                                                   {/* <span className="text-sm text-primary">View details</span> */}
//                                                   {/* <button
//                                                       className="px-3 py-1 text-sm border border-primary text-primary rounded hover:bg-primary hover:text-white transition-colors"
//                                                       title="Copy Prompt"
//                                                   >
//                                                       Copy
//                                                   </button> */}
//                                                   <button
//                                                       className="px-3 py-1 text-sm border border-primary text-primary rounded hover:bg-primary hover:text-white transition-colors"
//                                                       title="Copy Prompt"
//                                                       onClick={() => {
//                                                           const prompts = [];
//                                                           if (item.image_prompt) prompts.push(`Image Prompt: ${item.image_prompt}`);
//                                                           if (item.video_prompt) prompts.push(`Video Prompt: ${item.video_prompt}`);
              
//                                                           if (prompts.length === 0) return;
              
//                                                           const textToCopy = prompts.join("\n");
//                                                           navigator.clipboard.writeText(textToCopy).then(() => {
//                                                               setCopiedId(item._id);
//                                                               setTimeout(() => setCopiedId(null), 2000);
//                                                           });
//                                                       }}
//                                                   >
//                                                       {copiedId === item._id ? "Copied!" : "Copy Prompt"}
//                                                   </button>
              
              
//                                                   <div className="flex flex-row">
//                                                       {/* Save Icon */}
//                                                       {/* <button
//                                                           className="p-2 rounded-md hover: transition-colors "
//                                                           title="Save Prompt"
//                                                       >
//                                                           <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
//                                                       </button> */}
              
//                                                       <button type="button"
//                                                           onClick={() => handleToolNavigate(item?._id)}
//                                                       >
//                                                           <AnimatePresence mode="wait">
//                                                               {item?.is_saved ? (
//                                                                   <motion.div
//                                                                       key="saved"
//                                                                       initial={{ opacity: 0, scale: 0.5 }}
//                                                                       animate={{ opacity: 1, scale: 1 }}
//                                                                       exit={{ opacity: 0, scale: 0.5 }}
//                                                                       transition={{ duration: 0.3 }}
//                                                                   >
//                                                                       <BiBookmarkHeart className="w-5 h-5 text-primary hover:text-white" />
//                                                                   </motion.div>
//                                                               ) : (
//                                                                   <motion.div
//                                                                       key="unsaved"
//                                                                       initial={{ opacity: 0, scale: 0.5 }}
//                                                                       animate={{ opacity: 1, scale: 1 }}
//                                                                       exit={{ opacity: 0, scale: 0.5 }}
//                                                                       transition={{ duration: 0.3 }}
//                                                                   >
//                                                                       <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
//                                                                   </motion.div>
//                                                               )}
//                                                           </AnimatePresence>
//                                                       </button>
//                                                       {/* <button
//                 type="button"
//                 onClick={() => handleToolNavigate(item?._id)}
//                 className="group flex items-center gap-1 px-2 py-1 rounded border border-customBlue hover:bg-background-primary transition"
//               >
//                 <AnimatePresence mode="wait">
//                   {item?.is_saved ? (
//                     <motion.div
//                       key="saved"
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       exit={{ opacity: 0, scale: 0.5 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <div className="flex items-center gap-1">
//                         <BiBookmarkHeart className="w-4 h-4 text-primary group-hover:text-white" />
//                         <span className="text-xs text-primary group-hover:text-white font-medium">{item?.total_saved}</span>
//                       </div>
//                     </motion.div>
//                   ) : (
//                     <motion.div
//                       key="unsaved"
//                       initial={{ opacity: 0, scale: 0.5 }}
//                       animate={{ opacity: 1, scale: 1 }}
//                       exit={{ opacity: 0, scale: 0.5 }}
//                       transition={{ duration: 0.3 }}
//                     >
//                       <div className="flex items-center gap-1">
//                         <BiBookmark className="w-4 h-4 text-primary group-hover:text-white" />
//                         <span className="text-xs text-primary group-hover:text-white font-medium">{item?.total_saved}</span>
//                       </div>
//                     </motion.div>
//                   )}
//                 </AnimatePresence>
//               </button> */}
              
              
              
//                                                       <button
//                                                           className="p-2 rounded-md hover: transition-colors  cursor-pointer"
//                                                           title="Show details"
//                                                           type="button"
//                                                           onClick={() => {
//                                                               navigate(`/prompts-detail/${item?._id}`)
//                                                           }}
//                                                       >
//                                                           <FiExternalLink className="text-primary w-5 h-5  hover:text-white" />
//                                                       </button>
              
//                                                   </div>
//                                               </div>
//                                           </div>
//             ))}
//             {
//                 (data?.length===0) && <>
//                         <p className="text-white ">No prompts available</p>
//                 </>
//             }
//           </div>

//           {data.length < totalItems && (
//             <div className="flex justify-center mt-6">
//               <button
//                 onClick={handleLoadMore}
//                 className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
//               >
//                 Load More
//               </button>
//             </div>
//           )}
//         </div>
//       </section>

      
            

          
//         </div>
//     );
// };

// export default MyPrompts;


import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FiExternalLink, FiShare2 } from "react-icons/fi";
import { getDecryptedData } from "../../config/crypto";
import { IMAGE_URL, REACT_APP_API_PORT, VIDEO_URL } from "../../Api";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import Loader from "../Loader";
import { toast } from "react-toastify";
import { BiBookmark, BiBookmarkHeart } from "react-icons/bi";
import { motion, AnimatePresence } from "framer-motion";
import { FaBookmark, FaFileAlt } from "react-icons/fa";
const MyPrompts = () => {
  const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(8);
  const [copiedId, setCopiedId] = useState(null);
  const getData = async (page = currentPage) => {
    try {
      setIsLoading(true);
      const token = getDecryptedData("token")
      const user = getDecryptedData("user")
      let userId = ""
      if (user) {
        userId = user._id
      }
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/frontend/user_save_prompt_list?limit=${limit}&page=${page}&userId=${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": token,
          },
        }
      );
      setIsLoading(false);
      if (res.data.status) {
        setData(res.data.data);
        setTotalPages(res.data.pagination?.totalPages);
        setTotalItems(res.data.pagination?.totalItems);
      }
      else {
        setData([])
        setTotalItems(0)
        setTotalPages(0)
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData(currentPage);
  }, [currentPage, limit]);

  const handleLoadMore = () => {
    setLimit((prevLimit) => prevLimit + 8);
  };



  const handleToolNavigate = async (toolId) => {
    const user = getDecryptedData("user");
    if (!user) {
      navigate(`/login`)
    }
    if (user) {
      try {
        setIsLoading(true)
        const token = getDecryptedData('token')
        const res = await axios.post(`${REACT_APP_API_PORT}user/frontend/save-prompt`, {
          prompt_id: toolId,
        }, {
          headers: {
            'Content-Type': 'application/json',
            'x-access-token': token
          }
        });
        setIsLoading(false)
        if (res.data.status) {
          getData(1)
          setCurrentPage(1)
        }
      }
      catch (err) {
        setIsLoading(false)
        if (err.response.data.status === false) {
          toast.error(err.response.data.message)
        }
      }
    }
  }
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };
  return (
    <div className="container py-4">
      <Loader isLoading={isLoading} />
      <section className="bg-background-back1 overflow-hidden">
        <div className="container max-w-[80rem] mx-auto px-4 pt-5">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {data?.slice(0, limit).map((item) => (
              <div
                key={item._id}
                className="blurBox bg-gray-900 rounded-xl overflow-hidden shadow-lg p-4 transition-transform duration-200"
              // onClick={() => openSidebar(item)}
              >
                <div className="flex items-center gap-2"
                // onClick={() => openSidebar(item)}
                // onClick={() => {
                //     navigate(`/prompts-detail/${item?._id}`)
                // }}
                >
                  {/* <div className="relative">
                                  <img
                                    src={item.logo ? IMAGE_URL + item.logo + "?type=tool" : "/default.jpeg"}
                                    // onError={(e)=>e.src.target='/default.jpeg'}
                                    onError={(e) => {
                                      e.target.onerror = null; // Prevents infinite loop if default image fails
                                      e.target.src = '/default.jpeg';
                                    }}
                                    alt={`${item.tool_name} logo`}
                                    className="h-12 w-12 rounded-full"
                                  />
                                  {
                                    (item?.isVerified && item?.isVerified === "Yes") &&
                                    <span className="absolute -top-1 -right-1 h-4 w-4 flex items-center justify-center">
                                      <PiSealCheckFill className="text-primary h-4 w-4 bg-white rounded-full" />
                                    </span>
                                  }
              
                                </div> */}
                  <div className="flex flex-col truncate  cursor-pointer" onClick={() => navigate(`/prompts-detail/${item._id}`)}>
                    <h5 className="text-lg font-bold text-white truncate">
                      {item?.title?.length > 20 ? `${item?.title?.slice(0, 20)}...` : item.title}
                    </h5>
                    {/* <p className="text-sm text-gray-400 truncate flex items-center">
                      <FaFileAlt className="mr-1" size={14} /> Prompt
                    </p> */}
                  </div>
                </div>
                {/* <p className="text-sm text-gray-400 truncate">{item.short_description}</p> */}
                <p
                  onClick={() => navigate(`/prompts-detail/${item._id}`)}
                  className={`cursor-pointer text-[13px] md:text-[14px] text-gray-400 truncate `}
                >
                  {(() => {
                    const text = stripHtml(item.short_description);
                    return text.length > 330 ? text.slice(0, 330) + "..." : text;
                  })()}
                </p>
                <img
                  // onClick={() => {
                  //     if (item?.tool_name) {
                  //         navigate(`/tool-detail/${replaceSpacesWithHyphen(item?.tool_name)}/${item?._id}`)
                  //     }
                  //     else {
                  //         navigate(`/tool-detail/${item?._id}`)
                  //     }
                  // }}
                  src={item.image ? IMAGE_URL + item.image : "/just-launch-default.png"}
                  onError={(e) => {
                    e.target.onerror = null; // Prevents infinite loop if default image fails
                    e.target.src = '/just-launch-default.png';
                  }}
                  onClick={() => navigate(`/prompts-detail/${item._id}`)}
                  alt={item.title}
                  className="w-full mt-3 rounded-lg object-cover h-40 lg:h-40 cursor-pointer"
                />
                <div className="flex justify-between items-center mt-2">
                  {/* <span className="text-sm text-primary">View details</span> */}
                  {/* <button
                                                      className="px-3 py-1 text-sm border border-primary text-primary rounded hover:bg-primary hover:text-white transition-colors"
                                                      title="Copy Prompt"
                                                  >
                                                      Copy
                                                  </button> */}
                  <button
                    className="px-3 py-1  border border-customBlue text-white custom-back font-semibold rounded hover:bg-primary hover:text-white transition-colors text-[12px]"
                    title="Copy Prompt"
                    onClick={() => {
                      const prompts = [];
                      if (item.image_prompt) prompts.push(`Image Prompt: ${item.image_prompt}`);
                      if (item.video_prompt) prompts.push(`\nVideo Prompt: ${item.video_prompt}`);

                      if (prompts.length === 0) return;

                      const textToCopy = prompts.join("\n");
                      navigator.clipboard.writeText(textToCopy).then(() => {
                        setCopiedId(item._id);
                        setTimeout(() => setCopiedId(null), 2000);
                      });
                    }}
                  >
                    {copiedId === item._id ? "Copied!" : "Copy Prompt"}
                  </button>


                  <div className="flex flex-row">
                    {/* Save Icon */}
                    {/* <button
                                                          className="p-2 rounded-md hover: transition-colors "
                                                          title="Save Prompt"
                                                      >
                                                          <BiBookmark className="w-5 h-5 text-primary hover:text-white" />
                                                      </button> */}
                    <button
                      className="p-2 rounded-md hover:transition-colors cursor-pointer"
                      title="Share Prompt"
                      type="button"
                      onClick={() => {
                        const prompts = [];
                        if (item.image_prompt) prompts.push(`Image Prompt: ${item.image_prompt}`);
                        if (item.video_prompt) prompts.push(`\nVideo Prompt: ${item.video_prompt}`);

                        if (prompts.length === 0) return;

                        const textToShare = prompts.join("\n");

                        if (navigator.share) {
                          navigator.share({
                            title: `Check out this prompt ${item?.title}!`,
                            text: textToShare,
                          }).catch((err) => {
                            console.error("Error sharing:", err);
                          });
                        } else {
                          alert("Sharing not supported on this browser.");
                        }
                      }}
                    >
                     <div className="text-white bg-[#515151] flex items-center hover:bg-background-primary h-8 w-8 p-[5px] rounded text-[10px]">
                                                                                 <FiShare2 className="h-4 w-4 m-auto" />
                                                                             </div>
                    </button>

                    <button type="button"
                      onClick={() => handleToolNavigate(item?._id)}
                    >
                      <AnimatePresence mode="wait">
                        {item?.is_saved ? (
                          <motion.div
                            key="saved"
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.5 }}
                            transition={{ duration: 0.3 }}
                          >
                            <div className="text-white bg-[#515151] flex items-center hover:bg-background-primary h-8 w-8 p-[5px] rounded text-[10px]">
                              {/* <BiBookmarkHeart className="h-4 w-4 m-auto" /> */}
                               <FaBookmark className="h-4 w-4 m-auto" />
                            </div>
                          </motion.div>
                        ) : (
                          <motion.div
                            key="unsaved"
                            initial={{ opacity: 0, scale: 0.5 }}
                            animate={{ opacity: 1, scale: 1 }}
                            exit={{ opacity: 0, scale: 0.5 }}
                            transition={{ duration: 0.3 }}
                          >
                            <div className="text-white bg-[#515151] flex items-center hover:bg-background-primary h-8 w-8 p-[5px] rounded text-[10px]">
                              <BiBookmark className="h-4 w-4 m-auto" />
                            </div>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </button>
                    {/* <button
                type="button"
                onClick={() => handleToolNavigate(item?._id)}
                className="group flex items-center gap-1 px-2 py-1 rounded border border-customBlue hover:bg-background-primary transition"
              >
                <AnimatePresence mode="wait">
                  {item?.is_saved ? (
                    <motion.div
                      key="saved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="flex items-center gap-1">
                        <BiBookmarkHeart className="w-4 h-4 text-primary group-hover:text-white" />
                        <span className="text-xs text-primary group-hover:text-white font-medium">{item?.total_saved}</span>
                      </div>
                    </motion.div>
                  ) : (
                    <motion.div
                      key="unsaved"
                      initial={{ opacity: 0, scale: 0.5 }}
                      animate={{ opacity: 1, scale: 1 }}
                      exit={{ opacity: 0, scale: 0.5 }}
                      transition={{ duration: 0.3 }}
                    >
                      <div className="flex items-center gap-1">
                        <BiBookmark className="w-4 h-4 text-primary group-hover:text-white" />
                        <span className="text-xs text-primary group-hover:text-white font-medium">{item?.total_saved}</span>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </button> */}



                    {/* <button
                      className="p-2 rounded-md hover: transition-colors  cursor-pointer"
                      title="Show details"
                      type="button"
                      onClick={() => {
                        navigate(`/prompts-detail/${item?._id}`)
                      }}
                    >
                      <FiExternalLink className="text-primary w-5 h-5  hover:text-white" />
                    </button> */}

                  </div>
                </div>
              </div>
            ))}
            {
              (data?.length === 0) && <>
                <p className="text-white ">No prompts available</p>
              </>
            }
          </div>

          {data.length < totalItems && (
            <div className="flex justify-center mt-6">
              <button
                onClick={handleLoadMore}
                className="border-2 border-customBlue px-4 py-2 rounded text-white hover:bg-background-primary transition text-[15px] font-bold uppercase"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default MyPrompts;
